var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "twitter"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29363",
    "data-name": "Rectangle 29363",
    width: 22,
    height: 22,
    transform: "translate(13975 4549)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_702",
    "data-name": "Mask Group 702",
    transform: "translate(-13975 -4549)",
    clipPath: "url(#twitter)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "twitter",
    d: "M21.874,4.167a.478.478,0,0,0-.574-.1,4.085,4.085,0,0,1-.611.221,4.3,4.3,0,0,0,.727-1.4.478.478,0,0,0-.737-.515,10.053,10.053,0,0,1-2.3.9,4.813,4.813,0,0,0-6.031-.466A4.746,4.746,0,0,0,10.28,7.192,11.325,11.325,0,0,1,2.349,2.92a.5.5,0,0,0-.407-.179.478.478,0,0,0-.383.233,4.629,4.629,0,0,0-.528,3.594,5.118,5.118,0,0,0,.831,1.738A2.539,2.539,0,0,1,1.377,8a.478.478,0,0,0-.78.371,4.946,4.946,0,0,0,2.548,4.247,3.547,3.547,0,0,1-.616-.132.478.478,0,0,0-.574.654A5.22,5.22,0,0,0,5.579,16.1,8.427,8.427,0,0,1,.533,17.14a.472.472,0,0,0-.51.327.478.478,0,0,0,.22.564,14.334,14.334,0,0,0,7.069,2.009,12.14,12.14,0,0,0,6.709-2.052c3.791-2.516,6.153-7.032,5.824-11.074a8.934,8.934,0,0,0,2.08-2.167A.478.478,0,0,0,21.874,4.167Z",
    transform: "translate(13975 4549)",
    fill: "#03a9f4"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.2f4cc763862395a430bf22131d17d28e.svg";
export { ForwardRef as ReactComponent };